export default {
  IMAGE: 'image',
  FILE: 'file',
  DOC: 'doc',
};



// WEBPACK FOOTER //
// ./src/variables/fileTypes.js